<template>
    <div>
        <div style="text-align: center;padding-top:5%">
            <h1>《中国全科医学》杂志XML期刊数据上传</h1>
        </div>
        <div style="padding-left:35%;padding-top:3%; width:60%">
            <cgp-webupload :fileaccept="fileaccept" :Maxfileszie="Maxfileszie" :uploadtype="uploadtype" :orgid="orgid" :onSuccess="handleSuccess">
                <div style="background: rgb(11, 133, 134); color:#ffff;width: 100px; height: 35px;line-height: 35px;border-radius:30px">点击上传</div>
            </cgp-webupload>
            <span style="color: #0B8586;margin-left:10px" v-show="seecshow">{{ filename }} -上传成功</span>
        </div>
    </div>
</template>
<script>
import webupload from '../../components/webupload/webupload.vue';
export default {
    components: { 'cgp-webupload': webupload },
    data() {
        return {
            /**上传格式限制 */
            fileaccept: '',
            /**上传文件最大值 默认 10M（单位（M）*/
            Maxfileszie: 30720,
            /**上传类型：1：专家，2：机构，0：默认 */
            uploadtype: 0,
            /**机构或者专家ID*/
            orgid: -99,
            filename: '',
            seecshow: false
        };
    },
    methods: {
        handleSuccess(response, file) {
            this.filename = file.name;
            this.seecshow = true;
        }
    }
};
</script>
